export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="walogo" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#00F0FF" />
        <stop offset="1" stopColor="#0066FF" />
      </linearGradient>
    </defs>
    <rect x="4" y="4" width="56" height="56" rx="14" fill="#0B132B" stroke="url(#walogo)" strokeWidth="2.5" />
    <path
      d="M16 20 L24 44 L32 26 L40 44 L48 20"
      fill="none"
      stroke="url(#walogo)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="16" cy="20" r="3" fill="#00F0FF" />
    <circle cx="48" cy="20" r="3" fill="#0066FF" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark size={compact ? 30 : 36} />
    <span className="font-display leading-none">
      <span className="block text-[15px] font-bold tracking-tight text-slate-50">
        WA <span className="text-cyan-400">Digital</span>
      </span>
      <span className="mt-0.5 block font-mono text-[9px] uppercase tracking-[0.3em] text-slate-400">
        Solutions
      </span>
    </span>
  </span>
);
